import './styles/App.css';
import queryString from 'query-string';
import CarInfo from './components/Bojung/CarInfo';
import CustomerInfo from './components/Bojung/CustomerInfo';
import ServiceList from './components/Bojung/ServiceList';
import ServiceGuide from './components/Bojung/ServiceGuide';
import Cautions from './components/Bojung/Cautions';

function BojungOk({location}) {
    const query = queryString.parse(location.search);
    let r_id = query.r_id;


  return (
      <main className="mt-5 container">
        <h2 className="mb-4 text-center sigongOkTitle">시공 확인서</h2>
        <CarInfo r_id={r_id} /> 
        {false && <CustomerInfo />}
        <ServiceList r_id={r_id} />
        <ServiceGuide />
        <Cautions r_id={r_id}/>
      </main>
  );
}

export default BojungOk;